export const filterInLimitedCatalog = (products, cache) => {
  return products.filter(productIsInLimitedCatalog(cache));
};

export const filterProductsByParentCategories = (
  products,
  parentCategories
) => {
  return products.filter((product) => {
    return product.product_category_ids?.some((id) =>
      parentCategories.includes(id)
    );
  });
};

/**
 * Thunk which retuns a function which returns a boolean of whether a product is in the limited catalog
 *
 * @access public
 * @param {Array} cache of limited catalog products, index by product ID, values are limited catalog ID, null, or undefined
 * @returns {Function} with param of product
 */
export const productIsInLimitedCatalog = (cache) => {
  return (product) => {
    return (
      !!cache[product.id] ||
      (!!product.catalog_product_id && cache[product.id] !== null)
    );
  };
};

export const mergePopularProducts = (
  popularProducts = [],
  categoryProducts = []
) => {
  const popularProductsIds = popularProducts.map((product) => product.id);

  const filteredProducts = categoryProducts.filter((product) => {
    return !popularProductsIds.includes(product.id);
  });

  return popularProducts
    .concat(filteredProducts.slice(0, 8))
    .filter((product) => product.active);
};
